import { FranchiseItemDataTable } from 'interfaces/content/Ranking';
import RawHtml from 'utils/miscUtils/rawHtml';
import Link from 'components/Globals/Base/Link';
import { Description, Columns, Column, Wrapper, Item } from './StatsStyle';

export interface Props {
  data: FranchiseItemDataTable;
  className?: string;
}

const Stats = ({ data, className = '' }: Props) => {
  const { footnote, values, changeHeader, valueHeader } = data;
  const entries = values.length;
  return (
    <Wrapper className={className}>
      <Columns>
        {entries > 10 ? (
          <>
            <Column>
              {values.slice(0, Math.ceil(entries / 2)).map(({ title, value, change }) => (
                <Item key={title}>
                  <span>{title}:</span>
                  {title === 'Website' ? (
                    <Link
                      className='link'
                      href={value}
                      target='_blank'
                      rel='noopener noreferrer'
                      type='bluePrimary'
                      aria-label='Visit the company website'
                    >
                      {value}
                    </Link>
                  ) : (
                    <span>{RawHtml({ html: value })}</span>
                  )}
                  {change && <span>{change}</span>}
                </Item>
              ))}
            </Column>
            <Column>
              {values.slice(Math.ceil(entries / 2), entries).map(({ title, value, change }) => (
                <Item key={title}>
                  <span>{title}:</span>
                  <span>{RawHtml({ html: value })}</span>
                  {change && <span>{change}</span>}
                </Item>
              ))}
            </Column>
          </>
        ) : (
          <Column>
            {changeHeader && valueHeader && (
              <Item>
                <span />
                <span>{valueHeader.replace(/[{()}]/g, '')}</span>
                <span>{changeHeader}</span>
              </Item>
            )}
            {values.map(({ title, value, change }) => (
              <Item key={title}>
                <span>{title}:</span>
                <span>{value}</span>
                {change && <span>{change}</span>}
              </Item>
            ))}
          </Column>
        )}
      </Columns>
      {footnote && <Description>{footnote}</Description>}
    </Wrapper>
  );
};

export default Stats;
